module.exports = __webpack_public_path__ + "static/media/smutek-i-radosc.9d0b929d.jpg";